export default "__VITE_ASSET__fIvrQm2D__"